import { preloadPreviewImages } from "@/components/LoadingImage";
/**
 * Preloads lazy preview images for adjacent hidden tab slides on block hover
 * to avoid flashing when navigating prev/next.
 * Currently used for Collection Explorer and Brand Category Collection blocks.
 */
export function setupAdjacentSlidePreload({ element, slides, totalItems, getCurrentIndex, }) {
    const preloadedSlideIndices = new Set();
    let hasBlockHover = false;
    const preloadSlideImages = (index) => {
        if (index < 0 || index >= totalItems || preloadedSlideIndices.has(index)) {
            return;
        }
        const slide = slides[index];
        if (!slide) {
            return;
        }
        preloadPreviewImages(slide);
        preloadedSlideIndices.add(index);
    };
    const preloadAdjacentSlideImages = (currentIndex) => {
        if (totalItems <= 1) {
            return;
        }
        const prevIndex = (currentIndex - 1 + totalItems) % totalItems;
        const nextIndex = (currentIndex + 1) % totalItems;
        preloadSlideImages(prevIndex);
        preloadSlideImages(nextIndex);
    };
    const onBlockMouseEnter = () => {
        hasBlockHover = true;
        preloadAdjacentSlideImages(getCurrentIndex());
    };
    const onSlideChanged = (currentIndex) => {
        if (hasBlockHover) {
            preloadAdjacentSlideImages(currentIndex);
        }
    };
    element.addEventListener("mouseenter", onBlockMouseEnter);
    return {
        onSlideChanged,
        destroy: () => {
            element.removeEventListener("mouseenter", onBlockMouseEnter);
        },
    };
}
